import { Field, Int, ObjectType } from '@nestjs/graphql'

/** One of staff's internal notes on a Publisher application [sc-29190]. */
@ObjectType()
export class PublisherApplicationNoteDto {
  @Field(t => Int)
  id!: number

  @Field()
  text!: string

  @Field(t => Date)
  createdDate!: Date

  // The admin who wrote it; missing once their account is gone.
  @Field({ nullable: true })
  authorName?: string
}
